import React from 'react';
import Svg from "../Svg";

const IconServiceSkating = () => (
	<div className="icon-service icon-service-skating">
		<Svg width="14" height="14">
			<g strokeWidth="1" transform="translate(0.500000, 0)" fill="#FFFFFF">
				<path
					d="M13.5540128,13.7829677 C13.5540128,14.2793931 13.1503451,14.6839197 12.6539198,14.6839197 L10.5006262,14.6839197 L10.5006262,13.78125 L9.12729716,13.78125 L9.12729716,14.6839197 L4.44904624,14.6839197 L4.44904624,13.78125 L3.07571721,13.78125 L3.07571721,14.6839197 L2.49800181e-15,14.6839197 L2.49800181e-15,16.0572487 L12.6539198,16.0572487 C13.9078662,16.0572487 14.9282007,15.0377731 14.9282007,13.7829677 L13.5540128,13.7829677 Z"/>
				<path
					d="M14.2125564,9.49621902 C14.129979,8.94570304 13.7813189,8.48693972 13.2766793,8.25755807 L12.5701837,7.92724848 L11.6251313,9.63384801 L9.96440811,9.63384801 L11.2489454,7.30333037 L10.0469855,6.74363912 L8.59729343,9.28610542 L6.8906939,9.28610542 L8.90007722,5.78941143 L10.202965,1.44951046 L3.67597293,-1.14908083e-14 L0.961703433,12.0652936 L14.6162681,12.0652936 L14.2125564,9.49621902 Z"/>
			</g>
		</Svg>
	</div>
);

export default IconServiceSkating;
